export function StopIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.5"
        y="0.5"
        width="23"
        height="23"
        rx="5.5"
        stroke="var(--color-border-base-subdued)"
      />
      <rect
        x="7.5"
        y="7.5"
        width="9"
        height="9"
        rx="3"
        fill="var(--color-background-neutral-default)"
      />
    </svg>
  )
}
